<main role="main" class="page-historique not-home-page">
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <app-breadcrumb></app-breadcrumb> 
        <h2>{{bloc.Titre}}</h2>
        <p class="text-primary size18 font-weight-semibold">
          {{bloc.Contenu}}
        </p>
      </div>
    </div>
  </div>
  <section class="c-slider-full">
    <div class="time-line">
      <div class="track"></div>
      <div class="d-flex justify-content-between">
        <span *ngFor="let year of yearsArray" [class.big-step]="(1949+year)%5==0" class="time-line-step"
          [attr.data-year]="1949 + year">
          <span *ngIf="(1949+year)%5==0" class="d-none d-sm-block">{{1949 + year}}</span>
        </span>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="slider-historique" id="slider-historique">
            <ol>
              <li *ngFor="let data of historiqueData" [attr.data-year-start]="data.AnneeDebut"
                [attr.data-year-end]="data.AnneeFin">
                <span class="historique-date size18">{{debutToFin(data.AnneeDebut,data.AnneeFin)}}</span>
                <h4 class="size24">
                  {{data.TitreHistorique}}
                </h4>
                <p class="size18">
                  {{data.DescriptionHistorique}}
                </p>
              </li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  </section>
</main>